<div *ngIf="isBusy" 
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
    style="background: rgba(255,255,255,0.5); z-index: 10;">
    <fa-icon [icon]="faSpinner" [spin]="true" size="5x"></fa-icon>
</div>

<div class="modal-header">
    <h4 class="modal-title" translate>New berth proposal</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-6">
            <app-control 
                label='Berth' 
                [(ngModel)]="model.berthId" 
                type="codelist"
                codelist="Berth" 
                [required]="true" 
                [useCache]="false"/>
        </div>        
    </div>
    <div class="row">
        <div class="col-12">
            <app-control 
                label='Remark' 
                [(ngModel)]="model.agentNote" 
                type="string" 
                [required]="true"/>            
        </div>        
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary" (click)="activeModal.close()" translate>Cancel</button>
    <button class="btn btn-primary" (click)="confirm()" translate [disabled]="isValid">Save</button>
</div>
